module.exports = __webpack_public_path__ + "img/ir.5a533e25.svg";